import { appConfig } from "~/config";

const API_HOST = appConfig.api.host;
const API_URL = appConfig.api.url;

export const ENDPOINTS = {
  LOGIN: `auth/login`,
  SOCIAL_LOGIN: `auth/social/authenticate`,
  LOGOUT: `logout`,
  CURRENT_USER: `me`,
  USERS: `users`,
  FILE_UPLOAD: "file_uploads",
  FILE_TEMPORARY_URL: "uploads/tmp",
  MAIL_UNSUBSCRIBES: "/unsubscribes",
  REGISTER: `auth/register`,
  SURVEY: `surveys`,
  PACKAGE: `app/jobs/packages`,
  OUTFIT: `app/outfits/headshot-styles`,
  PAYMENT_SESSION: `app/payment/session`,
  PAYMENT_CONFIRM: `app/payment/session_confirm`,
  SEND_MAIL_RESET_PWD: "auth/account/reset_password/send_email",
  VERIFY_PASSCODE_RESET_PWD: "auth/account/reset_password/verify",
  RESET_PWD: "auth/account/reset_password",
  MY_JOB: "app/jobs",
  FAVORITE: "app/photos/:imageID/favorite",
  FAVORITE_ALL: "app/jobs/:jobID/favorite_all",
  JOB: "app/jobs",
  SEND_EMAIL_VERIFICATION: `auth/account/verification/send_email`,
  VERIFY_EMAIL_CODE: `auth/account/verify`,
  SHARED_JOB: "public/jobs/:slug/favorite_share",
  VOTE: "public/photos/:imageID/voting",
  QUOTA: "app/quota",
  SUBSCRIPTIONS: "app/subscriptions",
  BILLING_PORTAL: `app/payment/billing_portal`,
};
